<template>
  <vx-card>
    <vs-row class="mb-4">
      <vs-col class="flex" vs-justify="flex-end">
        <vs-button class="mr-2" color="secondary" type="border" @click="back">{{ $t("button.목록") }}</vs-button>
        <vs-button class="" color="secondary" @click="register">{{ $t("button.등록") }}</vs-button>
      </vs-col>
    </vs-row>

    <vs-row>
      <vs-col class="">
        <h5 class="mb-4"><i class="dot"></i>안전보건관리책임자 지시사항</h5>
      </vs-col>
    </vs-row>

    <vs-row class="mb-8">
      <vs-col class="flex flex-wrap" style="column-gap: 1rem">
        <div class="mb-4 grid items-center" style="grid-template-columns: 129px 1fr">
          <vs-col>제목</vs-col>
          <vs-col>
            <ml-input class="w-full" v-model="form.post_title" />
          </vs-col>
        </div>
        <div class="mb-4 grid items-center" style="grid-template-columns: 129px 1fr">
          <vs-col>작성자</vs-col>
          <vs-col>
            <ml-input class="w-full" v-model="form.writer" readonly />
          </vs-col>
        </div>
        <div class="mb-4 grid items-center" style="grid-template-columns: 129px 1fr">
          <vs-col>작성일</vs-col>
          <vs-col>
            <DateSelector v-model="form.createdDate" />
          </vs-col>
        </div>

        <vs-row class="w-full mb-4 grid" vs-align="center" vs-justify="center" style="grid-template-columns: 129px 1fr">
          <vs-col>내용</vs-col>
          <vs-col>
            <quill-editor class="vx-col flex-1 ql-edit-text" v-model="form.content" :options="quillOption"></quill-editor>
          </vs-col>
        </vs-row>

        <file-upload-module class="w-full" v-model="fileList"></file-upload-module>
      </vs-col>
    </vs-row>
  </vx-card>
</template>

<script>
import DateSelector from "@/components/selector/DateSelector.vue";
import FileUploadModule from "@/views/modules/FileUploadModule";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import moment from "moment";

export default {
  name: "CommunityBusinesssnewsCreate",
  components: { DateSelector, FileUploadModule, quillEditor },
  computed: {
    projectId() {
      return this.$route.params.proj_id;
    },
  },
  data() {
    return {
      boardSlug: "news",
      boardId: 16,

      quillOption: {
        placeholder: "내용을 입력해주세요",
      },

      form: {
        post_title: "", //사업장명
        writer: "", //작성자
        content: "",
        parentId: "",
        createdDate: moment(new Date()).format("YYYY-MM-DD"),
      },
      fileList: [],
    };
  },

  created() {
    this.init();
  },

  methods: {
    back() {
      this.$router.back();
    },

    async init() {
      await this.$store.dispatch("USER_INFO");
      this.form.writer = this.$store.state.auth.userInfo.name;
    },

    async register() {
      const projectId = this.projectId;
      const boardId = this.boardId;
      const title = this.form.post_title;

      let uploads = "";
      const listUploads = [];
      const uploadFileIds = [];

      if (this.fileList.length > 0) {
        for (const file of this.fileList) {
          listUploads.push(file);
          uploadFileIds.push(file.id);
        }
        uploads = JSON.stringify(uploadFileIds);
      }

      this.form.parentId = 0;
      const content = JSON.stringify(this.form);

      if (this.formCheck()) {
        await this.$store.dispatch("board/CREATE_POST", {
          projectId,
          boardId,
          title,
          content,
          uploads,
        });

        this.$router.back();
      }
    },

    formCheck() {
      if (this.form.post_title.trim().length <= 0) {
        alert("제목을 입력해주세요");
        return false;
      }

      return true;
    },
  },
};
</script>

<style>
.ql-edit-text .ql-editor {
  overflow-y: scroll;
  resize: vertical;
  min-height: 20em;
}
</style>
